// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes spin {
  to { transform: rotate(360deg); }
}
* { box-sizing: border-box; }
body { margin: 0; padding: 0; }
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,KAAK,yBAAyB,EAAE;AAClC;AACA,IAAI,sBAAsB,EAAE;AAC5B,OAAO,SAAS,EAAE,UAAU,EAAE","sourcesContent":["@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n* { box-sizing: border-box; }\nbody { margin: 0; padding: 0; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
